var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AElf from 'aelf-sdk';
import { WalletAccount } from './walletAccount.js';
import { wallet } from '@portkey-v1/utils';
export class AccountProvider {
    constructor(BIP44Path = "m/44'/1616'/0'/0/0") {
        this._BIP44Path = BIP44Path;
    }
    create(BIP44Path) {
        if (!BIP44Path) {
            BIP44Path = this._BIP44Path;
            this._BIP44Path = wallet.getNextBIP44Path(BIP44Path);
        }
        let baseWallet;
        if (this._mnemonic) {
            baseWallet = AElf.wallet.getWalletByMnemonic(this._mnemonic, BIP44Path);
        }
        else {
            baseWallet = AElf.wallet.createNewWallet(BIP44Path);
            this._mnemonic = baseWallet.mnemonic;
        }
        return new WalletAccount(baseWallet);
    }
    privateKeyToAccount(privateKey) {
        const baseWallet = AElf.wallet.getWalletByPrivateKey(privateKey);
        return new WalletAccount(baseWallet);
    }
    decrypt(keystore, password, _options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { privateKey } = AElf.wallet.keyStore.unlockKeystore(keystore, password);
            return this.privateKeyToAccount(privateKey);
        });
    }
}
